"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var header_component_1 = require("./header.component");
exports.Header = header_component_1.Header;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInZpZXdzL0FzaGVyL3BhcnRzL2hlYWRlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHVEQUF5QztBQUFqQyxvQ0FBQSxNQUFNLENBQUEifQ==